<template>
	<div>
		  <Breadcrumbs main="Product" title="Add Product" />
			 <div class="container-fluid">
				<div class="row">
				   <div class="col-sm-12">
					  <div class="card">
						 <div class="card-body">
 
							<div class="row mb-3">
							   	<div class="col-12">
									<router-link to="/products" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</router-link>
									<!-- <a href="#" @click.prevent="$router.go(-1)" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</a> -->
							   	</div>
							</div>
 
							<form  @submit.prevent="addProduct()" enctype="multipart/form-data">
								<div class="form theme-form">
									<div class="row">
										<div class="col-md-4">
											<div class="mb-3">
												<label class="control-label">Product Name<span class="text-danger">*</span></label>
												<input class="form-control" type="text" placeholder="" v-model="product_name_eng"/>
												<span class="validate-error" v-if="errors.name">
													{{ errors.name[0] }}
												</span>
											</div>
										</div>
									
										<div class="col-md-4">
											<div class="mb-3">
												<label class="control-label">Stock<span class="text-danger">*</span></label>
												<input class="form-control" type="number" placeholder="" v-model="product_stock"/>
												<span class="validate-error" v-if="errors.stock">
													{{ errors.stock[0] }}
												</span>	
											</div>
										</div>

										<div class="col-md-4">
											<div class="mb-3">
												<label class="control-label">Product Image<span class="text-danger">*</span></label>
												<input class="form-control" type="file" placeholder="Product Image" @change="handleFileChange"/>
												<span class="validate-error" v-if="errors.image">
													{{ errors.image[0] }}
												</span>	
											</div>
										</div>
										
									</div>

									<div class="row mt-3">
										<div class="col-sm-12">
											<button class="btn btn-success me-2 float-end" type="submit">Save</button>
										</div>
									</div>
	
								</div>
							</form>
						 </div>
					  </div>
				   </div>
				</div>
			 </div>
 
	</div>
 </template>

<script setup>

import { ref } from 'vue';
import { post } from '@/utils/api';
import { useRouter } from 'vue-router';
import Swal from '@/utils/swal';
import { routes } from '@/constants/routes';

const router = useRouter();

const product_name_eng = ref('');
const product_stock = ref('');
const product_image = ref(null);
let errors = ref({});

const handleFileChange = (e) => {
  const file = e.target.files[0];
  if (file) {
    product_image.value = file;
  }
};

const addProduct = () => {
  const formData = new FormData();
  formData.append('name', product_name_eng.value);
  formData.append('stock', product_stock.value);

  if (product_image.value) {
    formData.append('image', product_image.value);
  }

  post(routes.AddProduct, formData, false)
    .then((response) => {
      if (response.status === 200) {
        Swal.fire('', response.data.message || 'Product added successfully', 'success');
        router.push({ name: 'products' });
      } else {
        Swal.fire('', response.data.message || 'Failed to add product', 'error');
      }
    })
    .catch((error) => {
      if (error.response?.status === 422) {
		errors.value = error.response.data.message;
      } else if (error.response?.status === 500) {
        Swal.fire('', error.response.statusText || 'Server error', 'error');
      } else if (error.response?.status === 401) {
        Swal.fire('', error.response.statusText || 'Unauthorized', 'error');
        router.push({ name: 'login' });
      } else {
		Swal.fire('', error.response.data?.message || 'Error occured', 'error');
	  }
    });
};

</script>